<mat-dialog-content class="mat-typography">
  <div class="d-flex align-items-center justify-content-between m-b-16">
    <h4 class="f-s-16 f-w-600 m-b-16">Add New Contact</h4>
    <button
      mat-icon-button
      mat-dialog-close
      class="d-flex justify-content-center"
    >
      <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
  </div>

  <form #userForm="ngForm">
    <mat-label class="f-w-600 m-b-8 d-block">Upload Image</mat-label>
    <div class="file-input-container m-b-16">
      @if(local_data.contactimg){
      <img
        [src]="local_data.contactimg"
        alt="Selected Image"
        class="m-r-16"
        height="100"
        width="100"
      />
      }
      <input type="file" (change)="onFileSelected($event)" accept="image/*" />
    </div>
    <mat-label class="f-w-600 m-b-8 d-block">Name</mat-label>
    <mat-form-field appearance="outline" class="w-100">
      <input
        type="text"
        matInput
        required
        id="contactname"
        name="name"
        [(ngModel)]="local_data.Contactname"
        placeholder="Name"
      />
    </mat-form-field>
    <mat-label class="f-w-600 m-b-8 d-block">Post</mat-label>
    <mat-form-field appearance="outline" class="w-100">
      <mat-select [(value)]="local_data.ContactPost" name="post" required>
        <mat-option value="Web Designer">Web Designer</mat-option>
        <mat-option value="Theme Designer">Theme Designer</mat-option>
        <mat-option value="Front End Developer">Front End Developer</mat-option>
        <mat-option value="Hacker">Hacker</mat-option>
        <mat-option value="Back End Developer">Back End Developer</mat-option>
        <mat-option value="Graphics Designer">Graphics Designer</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-label class="f-w-600 m-b-8 d-block">Address</mat-label>
    <mat-form-field appearance="outline" class="w-100">
      <input
        type="text"
        matInput
        required
        id="contactadd"
        name="address"
        [(ngModel)]="local_data.Contactadd"
        placeholder="Address"
      />
    </mat-form-field>

    <mat-label class="f-w-600 m-b-8 d-block">Contact Number</mat-label>
    <mat-form-field appearance="outline" class="w-100">
      <input
        type="text"
        matInput
        required
        id="contactno"
        name="contact"
        (input)="validateNumber($event)"
        [(ngModel)]="local_data.Contactno"
        pattern="[0-9]*"
        maxlength="15"
        placeholder="Contact Number"
      />
    </mat-form-field>

    <div class="row">
      <div class="col-md-4">
        <mat-label class="f-w-600 m-b-8 d-block">Instagram Followers</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <input
            type="text"
            matInput
            required
            id="contactinsta"
            (input)="validateNumber($event)"
            name="insta"
            [(ngModel)]="local_data.Contactinstagram"
            placeholder="Followers"
          />
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <mat-label class="f-w-600 m-b-8 d-block">Linkedin Followers</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <input
            type="text"
            matInput
            required
            id="contactlinked"
            (input)="validateNumber($event)"
            name="linkedin"
            [(ngModel)]="local_data.Contactlinkedin"
            placeholder="Followers"
          />
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <mat-label class="f-w-600 m-b-8 d-block">Facebook Followers</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <input
            type="text"
            matInput
            required
            id="contactfacebook"
            (input)="validateNumber($event)"
            name="facebook"
            [(ngModel)]="local_data.Contactfacebook"
            placeholder="Followers"
          />
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
  <button
    mat-flat-button
    [mat-dialog-close]="true"
    [disabled]="!userForm.form.valid"
    color="primary"
    (click)="doAction();"
  >
    Add Contact
  </button>
  <button mat-flat-button class="bg-error text-white" mat-dialog-close>
    Cancel
  </button>
</mat-dialog-actions>
